export enum FileTypesEnum {
  Image,
  Audio,
  Movie,
  MP3,
  Doc,
  Pdf,
  Other
}